export const BOBErrorState = {
	BOBErrorTitle: 'Something went wrong, please try again later.',
	BOBErrorBody: 'If the problem persists, please reach out to'
};
